import { Benchmark } from "../types/benchmark.type";

export interface BenchmarkZoneWidths {
  belowPercent: number;
  withinPercent: number;
  abovePercent: number;
}

/**
 * getBenchmarkZoneWidths function
 * Splits a benchmark's score range into the width (in percentage points) of the
 * below/within/above zones for the benchmark chart.
 *
 * @param benchmark - The applied benchmark
 * @returns The below/within/above zone widths, each 0-100
 */
export const getBenchmarkZoneWidths = (benchmark: Benchmark): BenchmarkZoneWidths => ({
  belowPercent: benchmark.scoreRangeMin,
  withinPercent: benchmark.scoreRangeMax - benchmark.scoreRangeMin,
  abovePercent: 100 - benchmark.scoreRangeMax,
});
